export default "__VITE_ASSET__eb528dcb__"